import { jwtDecode } from "jwt-decode";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import GlobalToast from "./components/GlobalStore";
import { UserProvider } from "./context/userContext";
import DrawerAppBar from "./screens/refonte/DrawerAppBar";
import AdminAppDrawer from "./screens/refonte/admin/AdminAppDrawer";
import AuthService from "./service/AuthService";

function App() {
  const [currentUser, setCurrentUser] = React.useState(null);
  const current_url = window.location.href;
  const is_administration = current_url.split("/").at(3)?.includes("administration");
  const location = useLocation();

  /**
   * Vérifie le token JWT si c'est valide
   */
  const isTokenValid = (token) => {
    try {
      const decoded = jwtDecode(token);
      return decoded.exp > Date.now() / 1000;
    } catch (error) {
      return false;
    }
  };

  const handleCheckToken = () => {
    const token = localStorage.getItem("TOKEN");
    if (token && isTokenValid(token)) {
      const u = jwtDecode(token);
      if (is_administration && u.scope.split(":")[1] !== "7") {
        AuthService.logOut();
      }
    } else {
      AuthService.logOut();
    }
  };

  useEffect(() => {
    handleCheckToken();
  }, [location]);

  return (
    <UserProvider>
      {is_administration ? <AdminAppDrawer /> : <DrawerAppBar />}
      <GlobalToast />
    </UserProvider>
  );
}

export default App;
